import { DataGridPro, GridColDef } from "@mui/x-data-grid-pro";
import { Profile, ProfileStatus } from "models/profile/Profile";
import { useEffect, useState } from "react";
import { formatDateTime } from "utils/globalsUtils";
import { useNavigate } from "react-router-dom";
import { capitalize } from "@mui/material";
import { UserName } from "components/alove/UserName";
import { TwoSizeChip } from "components/alove/Chips";
import { Icon } from "@mui/material";
import { getNamesAsync, getProfileByExternalInfo } from "utils/enduserUtils";

interface MatchingProfilesProps {
  tagRuleKey: string;
}

export const MatchingProfiles = ({ tagRuleKey }: MatchingProfilesProps) => {
  const [profiles, setProfiles] = useState<Profile[]>([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!tagRuleKey) return;
    
    setLoading(true);
    getProfileByExternalInfo(tagRuleKey, "tagRules")
      .then((profiles) => {
        setProfiles(profiles || []);
        getNamesAsync(profiles.map((p) => p.userId))
      })
      .catch((error) => {
        console.error("Error fetching matching profiles:", error);
        setProfiles([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [tagRuleKey]);

  const columns: GridColDef[] = [
    {
      headerName: "First Name",
      field: "firstName",
      flex: 1,
      minWidth: 100,
      renderCell: (params) => <UserName userId={params.row.userId} />,
    },
    {
      headerName: "Gender",
      field: "gender",
      valueGetter: (v: string, p: Profile) => capitalize(p.attributesValues?.gender?.[0] || ""),
    },
    {
      headerName: "Type",
      field: "type",
      valueGetter: (v: string, p: Profile) =>
        capitalize(p.attributesValues?.userType?.[0]?.toString() || ""),
    },
    {
      headerName: "Created",
      field: "created",
      flex: 1,
      minWidth: 170,
      align: "center",
      renderCell: (params) => formatDateTime(params.row.created),
    },
    {
      headerName: "Status",
      field: "statusId",
      flex: 1,
      minWidth: 100,
      align: "center",
      renderCell: (params) => {
        const user = Object.assign(new Profile(), params.row);
        return <TwoSizeChip label={user.statusLabel} color={user.statusColor as any} />;
      },
    },
    {
      headerName: "Actions",
      field: "actions",
      flex: 1,
      align: "center",
      renderCell: (params) => (
        <Icon onClick={() => navigate(`/endUsers/${params.id}`)}>edit</Icon>
      ),
    },
  ];

  return (
    <DataGridPro
      rows={profiles}
      columns={columns}
      loading={loading}
      autoHeight
      disableRowSelectionOnClick
      getRowId={(row) => row.id || row.profileId}
      localeText={{ noRowsLabel: "No matching profiles found" }}
    />
  );
}; 